


































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateGroupWings, FilterWings, SelectWings, NumberWings, FilterSelectedItemWings, InputWings } from "wings-ui-components";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { Action, Getter, Mutation } from "vuex-class";
import { GroupFilterParams } from "@/store/custom/statistic/types";
import { MsgTransports } from '@/store/types';
import { notifyError, notifySuccess, notifyWarning } from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import i18n from "@/plugins/i18n";

@Component({
  components: {FilterSelectedItemWings, SelectWings, FilterWings, DatePickerWings, FastDateGroupWings, NumberWings, InputWings},
  filters: {dateFilter}
})
export default class CustomGroupFilter extends BaseFilter<GroupFilterParams> {

  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;

  @Mutation('setCustomStatisticGroup') setStatistic: any

  @Action("getCustomStatisticGroup") actionGetStatistic: any;
  @Action("exportCustomStatisticGroup") actionExport: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("actionLog") actionLog: any;

  @Getter("customGroupBy") groupByList: any;
  @Getter("customGroupByOptionally") optionallyGroupByList: any;
  @Getter("messageTypes") messageTypesList: any;
  @Getter("originators") originatorsList: any;

  groupBy = null;
  optionallyGroupBy = null;

  defaultFilter(): GroupFilterParams {
    return new GroupFilterParams(beginningOfCurrentDay(), currentDateEnd(), "day");
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.groupBy = item;
      else this.optionallyGroupBy = item;
    })
  }

  mergeGroupBy() {
    this.filter.group_by = [this.groupBy, this.optionallyGroupBy].filter(item => item).join(',')
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.groupBy, optionallyGroupBy: this.optionallyGroupBy})
  }

  created() {
    this.setStatistic(null)
    this.actionGetOriginators({transport: MsgTransports.CUSTOM});
    this.actionGetMessageTypes()
    this.parseGroupBy()
  }

  async onFilteredAction() {
    this.setStatistic(null)
    this.logObject = {
      actionPage: this.$route.meta.msgKey,
      action: "Viewing",
      actionStatus: 'success',
      objectType: "Group statistics",
      addititionalInfo: getTranslatedParams({...this.filter, ...this.getTranslatedGroupBy()})
    }
    this.mergeGroupBy()
    try {
      const resp = await this.actionGetStatistic(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning()
      }
    } catch(err) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(err)
    }
  }

  // Override
  async doActionExport() {
    this.logObject = {
      actionPage: this.$route.meta.msgKey,
      action: "Export",
      actionStatus: 'success',
      objectType: "Group statistics",
      addititionalInfo: getTranslatedParams({...this.filter, ...this.getTranslatedGroupBy()})
    }
    this.mergeGroupBy()
    try {
      await this.actionExport(this.sendFilter);
      await this.actionLog(this.logObject)
      notifySuccess(this.$t('dialog.export').toString());
    } catch(err) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(err)
    }
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChanged(newVal: GroupFilterParams) {
    this.propFilterClone = newVal;
  }

  getTranslatedGroupBy(): object{
    return {
      group_by: `${i18n.t('values.group_by.' + this.groupBy,'ru')} / ${i18n.t('values.group_by.'+this.groupBy,'en')}`,
      group_by_optionally: `${i18n.t('values.group_by.'+this.optionallyGroupBy,'ru')} / ${i18n.t('values.group_by.'+this.optionallyGroupBy,'en')}`
    }
  }
}
